import { useState, type ReactNode } from "react";
import { mainSiteUrl } from "./site";

export function SiteChrome({
  gated,
  overlay,
  children,
}: {
  gated?: boolean;
  overlay?: ReactNode;
  children: ReactNode;
}) {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className={gated ? "site-wrap app-gated" : "site-wrap"}>
      <header className="site-header">
        <div className="site-header-inner">
          <a className="site-logo" href={mainSiteUrl("/")}>
            <span>Non JUPAS 資訊頻道</span>
          </a>
          <button
            className="site-toggler"
            type="button"
            aria-label={navOpen ? "關閉選單" : "開啟選單"}
            aria-expanded={navOpen}
            onClick={() => setNavOpen(open => !open)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <nav className={navOpen ? "site-nav-wrap is-open" : "site-nav-wrap"}>
            <ul className="site-nav">
              <li>
                <a href={mainSiteUrl("/api/search")}>派位紀錄</a>
              </li>
              <li className="has-sub">
                <a href={mainSiteUrl("/nonjupas/preparing-to-apply")}>
                  申請攻略 <i className="fa-solid fa-chevron-down site-nav-caret" aria-hidden="true" />
                </a>
                <ul>
                  <li>
                    <a href={mainSiteUrl("/nonjupas/preparing-to-apply")}>報名須知</a>
                  </li>
                  <li>
                    <a href={mainSiteUrl("/nonjupas/non-jupas-personal-statement")}>Personal Statement</a>
                  </li>
                  <li>
                    <a href={mainSiteUrl("/nonjupas/request-for-reference-letter")}>Reference Letter</a>
                  </li>
                  <li>
                    <a href={mainSiteUrl("/nonjupas/design-portfolio")}>設計系 Portfolio</a>
                  </li>
                </ul>
              </li>
              <li className="active">
              <a href="/" aria-current="page">
                  入學統計
                </a>
              </li>
              <li>
                <a href="https://t.me/nonjupas" target="_blank" rel="noopener">
                  討論區 <i className="fa-brands fa-telegram" aria-hidden="true" />
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <main className="site-main">
        <div className="site-container">{children}</div>
      </main>

      <footer className="site-footer">
        <div className="site-footer-inner">
          <nav className="footer-cms-nav" aria-label="其他欄目">
            <a href={mainSiteUrl("/dse-jupas/")}>DSE & JUPAS</a>
            <a href={mainSiteUrl("/nonjupas/")}>Non JUPAS</a>
            <a href={mainSiteUrl("/igcse-ielts/")}>IELTS & IGCSE</a>
            <a href={mainSiteUrl("/career-plan/")}>Career Plan</a>
          </nav>
          <p className="footer-legal">{new Date().getFullYear()} Non JUPAS 資訊頻道 · 版權所有</p>
     
        </div>
      </footer>
      {overlay}
    </div>
  );
}

export function ResourceGrid() {
  return (
    <div className="resource-grid">
      <div className="nj-card resource-card resource-split">
        <a className="resource-main" href={mainSiteUrl("/api/search")}>
          <span className="resource-icon" aria-hidden="true">
            <i className="fa-solid fa-magnifying-glass" />
          </span>
          <span className="resource-label">Non JUPAS 派位紀錄</span>
        </a>
        <a className="resource-fill" href={mainSiteUrl("/api/offer")}>
          <span className="resource-icon" aria-hidden="true">
            <i className="fa-solid fa-pen" />
          </span>
          <span className="resource-label">填資料</span>
        </a>
      </div>
      <a className="nj-card resource-card" href="/">
        <span className="resource-icon" aria-hidden="true">
          <i className="fa-solid fa-chart-column" />
        </span>
        <span className="resource-label">官方入學統計資料</span>
      </a>
      <div className="nj-card resource-card resource-follow">
        <span className="resource-follow-title">關注我們</span>
        <nav className="resource-social" aria-label="社交平台">
          <a href="https://t.me/nonjupas" target="_blank" rel="noopener">
            <i className="fa-brands fa-telegram" aria-hidden="true" /> Telegram
          </a>
          <a href="https://www.threads.net/@nonjupas.hk" target="_blank" rel="noopener">
            <i className="fa-brands fa-threads" aria-hidden="true" /> Threads
          </a>
          <a href="https://www.youtube.com/@nonjupas" target="_blank" rel="noopener">
            <i className="fa-brands fa-youtube" aria-hidden="true" /> YouTube
          </a>
        </nav>
      </div>
    </div>
  );
}

